// 时间戳转化成日期
export const timestampToTime = timestamp => {
  let date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  let days =
    date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  if (hours < 10) hours = '0' + hours
  if (minutes < 10) minutes = '0' + minutes
  if (seconds < 10) seconds = '0' + seconds
  return Y + M + days + ' ' + hours + ':' + minutes + ':' + seconds
}

// 时间戳转化成字符串
export const formatDuring = timestamp => {
  let date = new Date(Number(timestamp))
  let hour = pad(date.getHours())
  let mimutes = pad(date.getMinutes())
  let seconds = pad(date.getSeconds())
  return `${hour}:${mimutes}:${seconds}`
}

function pad(n) {
  return n > 9 ? n : '0' + n
}
